module.exports = __webpack_public_path__ + "img/tax_b1@2x.a8094172.png";